import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Named for what it IS, not what it looks like.
 *
 * Empty states carry real weight in an HRMS: "no leave requests" and "you have no permission to
 * see leave requests" look identical if a screen just renders nothing, and the second one sends
 * people to the helpdesk. Giving this a component makes callers supply a sentence.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-12', className)}>
      {icon && <div className="text-fg-subtle">{icon}</div>}
      <div className="text-center">
        <p className="font-medium text-fg">{title}</p>
        {description && <p className="mt-1 max-w-sm text-sm text-fg-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}
